export default {
  name: 'CategoryLayout',

  props: [],

  data() {
    return {};
  },

  computed: {},

  methods: {

  },
};



// WEBPACK FOOTER //
// ./src/components/Help/CategoryLayout/component.js